export const attendance = {
  'attendance.status.PRESENT': 'حاضر',
  'attendance.status.ABSENT': 'غائب',
  'attendance.status.LATE': 'متأخر',
  'attendance.status.EXCUSED': 'بعذر',
  'attendance.status.none': 'لم يُحدَّد',
  'attendance.today.title': 'الحضور اليومي',
  'attendance.date': 'التاريخ',
  'attendance.today.report': 'التقرير الشهري',
  'attendance.holiday': 'هذا اليوم عطلة مدرسية؛ لا يُسجَّل فيه حضور.',
  'attendance.totals.classes': 'الشعب المكتملة',
  'attendance.totals.classesValue': '{done} من {total}',
  'attendance.totals.marked': 'سُجّل {marked} من {students}',
  'attendance.totals.present': 'حاضرون',
  'attendance.totals.absent': 'غائبون',
  'attendance.totals.late': 'متأخرون',
  'attendance.totals.excused': 'بعذر',
  'attendance.totals.ofMarked': 'من {n} مسجّلين',
  'attendance.classes.title': 'الشعب',
  'attendance.classes.done': 'مكتمل',
  'attendance.classes.partial': 'جزئي',
  'attendance.classes.pending': 'لم يُسجَّل',
  'attendance.classes.progress': '{marked} من {students}',
  'attendance.classes.empty': 'لا توجد شعب',
  'attendance.classes.emptyBody': 'أنشئ الشعب من الإعدادات أولاً.',
  'attendance.classes.noStudents': 'لا طلاب',
  'attendance.classes.open': 'فتح سجل الحضور',
  'attendance.absentees.title': 'الغائبون والمتأخرون',
  'attendance.absentees.empty': 'لا غياب ولا تأخير في هذا اليوم',
  'attendance.absentees.student': 'الطالب',
  'attendance.absentees.class': 'الشعبة',
  'attendance.absentees.status': 'الحالة',
  'attendance.absentees.note': 'ملاحظة',
  'attendance.absentees.guardian': 'ولي الأمر',
  'attendance.absentees.call': 'اتصال',
  'attendance.roster.back': 'الحضور اليومي',
  'attendance.roster.allPresent': 'الكل حاضر',
  'attendance.roster.allPresentHint': 'يُحدَّد كل طالب غير محدَّد «حاضراً»، ثم غيّر الغائبين.',
  'attendance.roster.unmarked': 'غير محدَّد: {n}',
  'attendance.roster.note': 'ملاحظة',
  'attendance.roster.addNote': 'إضافة ملاحظة',
  'attendance.roster.notePlaceholder': 'مثلاً: مريض، موعد طبي',
  'attendance.roster.save': 'حفظ الحضور',
  'attendance.roster.saved': 'حُفظ الحضور',
  'attendance.roster.noChanges': 'لا تغييرات للحفظ',
  'attendance.roster.changes': 'تغييرات غير محفوظة: {n}',
  'attendance.roster.lastSaved': 'آخر حفظ {time}',
  'attendance.roster.notSaved': 'لم يُحفظ بعد',
  'attendance.roster.empty': 'لا يوجد طلاب في هذه الشعبة في هذا اليوم',
  'attendance.roster.readOnlyAccountant': 'عرض فقط: الحضور يسجّله المدرّس أو إدارة المدرسة.',
  'attendance.roster.retrySafe': 'لم يُحفظ الحضور. أعد المحاولة؛ الحفظ آمن ولن يُرسل تنبيه مكرر لأولياء الأمور.',
  'attendance.roster.alertHint': 'يصل تنبيه في التطبيق لأولياء أمور الغائبين والمتأخرين اليوم.',
  'attendance.roster.leaveTitle': 'تغييرات غير محفوظة',
  'attendance.roster.leaveBody': 'لم تحفظ الحضور بعد. هل تريد مغادرة الصفحة وتجاهل التغييرات؟',
  'attendance.roster.leave': 'مغادرة دون حفظ',
  'attendance.roster.stay': 'البقاء',
  'attendance.roster.studentsCount': '{n}',
  'attendance.report.title': 'تقرير الحضور الشهري',
  'attendance.report.subtitle': 'أيام مسجّلة: {n}',
  'attendance.report.class': 'الشعبة',
  'attendance.report.allClasses': 'كل الشعب',
  'attendance.report.month': 'الشهر',
  'attendance.report.export': 'تصدير إلى Excel',
  'attendance.report.code': 'الرمز',
  'attendance.report.student': 'الطالب',
  'attendance.report.rate': 'نسبة الحضور',
  'attendance.report.empty': 'لا حضور مسجّل في هذا الشهر',
  'attendance.report.emptyBody': 'يظهر التقرير بعد أن يسجّل المدرّسون الحضور.',
  'attendance.report.rateHint': 'المتأخر يُحتسب حاضراً.',
  'attendance.student.tab': 'الحضور',
  'attendance.student.statementTab': 'كشف الحساب',
  'attendance.student.month': 'الشهر',
  'attendance.student.rate': 'نسبة الحضور',
  'attendance.student.none': 'لا حضور مسجّل في هذا الشهر',
  'attendance.student.notes': 'ملاحظات الأيام',
  'attendance.student.calendar': 'تقويم الشهر',
  'attendance.teacherOff.title': 'لا توجد شاشات لدورك على الويب',
  'attendance.teacherOff.body': 'حضور الطلاب متوقف في مدرستك. استخدم تطبيق تباشير على الهاتف.',
  'attendance.kpi.title': 'الحضور اليوم',
  'attendance.kpi.classes': '{done} من {total}',
  'attendance.kpi.absent': 'غائبون {absent}، متأخرون {late}',
  'attendance.kpi.holiday': 'عطلة مدرسية',
  'attendance.lesson.myLessons': 'حصصي',
  'attendance.lesson.title': 'حضور الحصة',
  'attendance.lesson.period': 'الحصة {n}',
  'attendance.lesson.short': 'ح{n}',
  'attendance.lesson.taken': 'سُجّل',
  'attendance.lesson.notTaken': 'لم يُسجّل',
  'attendance.lesson.none': 'لا حصص لك في هذا اليوم',
  'attendance.lesson.noneBody': 'تظهر هنا الحصص المسندة إليك في الجدول الدراسي.',
  'attendance.lesson.notSchoolDay': 'ليس يوم دوام',
  'attendance.lesson.back': 'حصصي',
  'attendance.lesson.before': '{status} في حصة سابقة',
  'attendance.lesson.readOnly': 'عرض فقط: يسجّل حضور الحصة مدرّسها، اليوم وحتى ستة أيام مضت.',
  'attendance.day.lessons': 'حصص اليوم المسجّلة:',
  'attendance.day.byHand': 'سُجّل يدوياً',
  'attendance.day.teachersMarkLessons': 'يُحسب حضور اليوم من حصص المدرّسين. يعدّله المدير أو المالك فقط.',
  'attendance.day.correctionHint': 'تعديل يوم طالب هنا يثبّته، ولا تغيّره حصص اليوم بعد ذلك.',
} as const;
